module.exports = __webpack_public_path__ + "public/Icons/manage_riders.svg?2b98226f";